import { useTranslation } from 'react-i18next'
import ActionModal from 'components/Modal/ActionModal'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { OPERATION_DISABLE_COUPONS } from '../operations-gql/mutations'
import { useMutation } from '@apollo/client'
import { toast } from 'components/global/CUK/Toast/Toast';
import  { OPERATION_FIND_COUPON_STANDARD, OPERATION_FIND_COUPON_H3 } from '../operations-gql/queries'
import { trackEvent } from 'analytics'

const DisableCode = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = useParams()
 
  const [disableCoupon, {loading}] = useMutation(OPERATION_DISABLE_COUPONS, {
    update: (cache) => {
      cache.updateQuery(
        {
          query: (/^\/codes\/standard/).test(location.pathname) ? OPERATION_FIND_COUPON_STANDARD : OPERATION_FIND_COUPON_H3,
          variables: {
            id: +id,
          },
        },
        (oldData) => {
          return { coupon: {...oldData.coupon, disabled: true, available: false, expired : false, valid : false, used : false } }
        },
      )
      onClose();
    },
    onCompleted: () => {
      trackEvent('disable_code', { code_type: 'standard' })
      toast.success(t('coupons.actions.desactivate_code.toast_success'));
    },
    onError: () => {
      toast.error(t('coupons.actions.desactivate_code.toast_error'));
    },
  })

  const onClose = () => {
    navigate({ pathname: '..' })
  }

  const handleConfirm = () => {
    disableCoupon({
      variables: {
        id: +id,
      },
    })
  }

  return (
    <ActionModal
      cancelLabel={t('ran.actions.cancel')}
      confirmLabel={t('coupons.actions.deactivate_user.modal_button')}
      description={t('coupons.actions.delete.modal_message')}
      icon={<i className="fa-light fa-pause" />}
      loading={loading}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={t('coupons.actions.delete.modal_title')}
    />
  )
}

export default DisableCode
